import { render, staticRenderFns } from "./AreaManagerTasks.vue?vue&type=template&id=3b52e138"
import script from "./AreaManagerTasks.vue?vue&type=script&lang=js"
export * from "./AreaManagerTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports